import React from 'react';
import './Footer.css';

const Footer = () => {
  const handleAddressClick = () => {
    window.open('https://www.google.com/maps/place/Auto-Kar+mgr.+inż.+Janusz+Karwiński/@50.8882878,21.0876103,13.95z/data=!4m6!3m5!1s0x47181b0486a23541:0x680189a0473c214b!8m2!3d50.8948767!4d21.0972945!16s%2Fg%2F11cryd8r2_?entry=ttu&g_ep=EgoyMDI1MDcwOS4wIKXMDSoASAFQAw%3D%3D', '_blank');
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:+48413177175';
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:autokar@interia.pl';
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Auto-Kar</h3>
            <p>Profesjonalny warsztat samochodowy oferujący kompleksowe usługi dla wszystkich marek pojazdów.</p>
          </div>
          
          <div className="footer-section">
            <h4>Kontakt</h4>
            <ul>
              <li className="footer-contact-item" onClick={handleAddressClick}>📍 ul. Kolejowa 22, Rudki k. Nowa Słupia</li>
              <li className="footer-contact-item" onClick={handlePhoneClick}>📞 +48 41 317 71 75</li>
              <li className="footer-contact-item" onClick={handleEmailClick}>📧 autokar@interia.pl</li>
            </ul>
            <div className="footer-map">
              <iframe
                title="Mapa Auto-Kar"
                src="https://maps.google.com/maps?q=50.8948767,21.0972945&hl=pl&z=15&output=embed"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Godziny pracy</h4>
            <ul>
              <li>Poniedziałek - Piątek: 7:30 - 17:00</li>
              <li>Sobota: 7:30 - 14:00</li>
              <li>Niedziela: Zamknięte</li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Auto-Kar Warsztat Samochodowy. Wszelkie prawa zastrzeżone.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 